import { OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
var PopUpWatchListComponent = /** @class */ (function () {
    function PopUpWatchListComponent(router, dialogRef, data) {
        this.router = router;
        this.dialogRef = dialogRef;
        this.data = data;
        this.docChecks = {
            funds: false,
            itinerary: false,
            hotel: false,
            flight: false,
            isAcknowledged: false,
        };
        this.duplicateData = data;
    }
    Object.defineProperty(PopUpWatchListComponent.prototype, "areAllDocsChecked", {
        get: function () {
            return (this.docChecks.funds &&
                this.docChecks.itinerary &&
                this.docChecks.hotel &&
                this.docChecks.flight &&
                this.docChecks.isAcknowledged);
        },
        enumerable: true,
        configurable: true
    });
    PopUpWatchListComponent.prototype.ngOnInit = function () {
        console.log(this.duplicateData);
    };
    PopUpWatchListComponent.prototype.onContinue = function () {
        // Require all document checkboxes before allowing confirm.
        if (!this.areAllDocsChecked)
            return;
        this.dialogRef.close("continue");
    };
    return PopUpWatchListComponent;
}());
export { PopUpWatchListComponent };
